import { useMemo } from 'react'
import { Box } from '@mui/material'
import { LeafletMap } from '../index'
import { get } from 'lodash'
import { SearchResultPopup } from '../../results'
import { transformResultToLeafletPlaces } from '../../../local/utils'
import { Search211Record, LeafletPlace } from '../../../definitions'
import './PlaceMap.scss'

/**
 * @typedef {Object} PlaceMapProps
 * @property {Search211Record=} place
 */

/**
 * Render single search result place map.
 * @param {PlaceMapProps} place
 * @return {JSX.Element}
 */
const PlaceMap = ({ place }) => {
  // The search result is retrieved from 211 API in backed, we access the
  // record through Drupal JS settings.
  const searchRecordJSON = get(window || {}, 'drupalSettings.searchResult', place || '{}')

  /**
   * @type {Search211Record}
   */
  const searchRecord = JSON.parse(searchRecordJSON)

  const distance = useMemo(() => {
    const distances = localStorage.getItem('resultDistances')
    if (!distances) return ''
    const distanceMap = new Map(Object.entries(JSON.parse(distances)))
    return distanceMap.get(`${searchRecord.id}`) ?? ''
  }, [searchRecord.id])

  // Search record not available, don't render anything.
  if (!searchRecord.id) {
    return null
  }

  /**
   * @type {LeafletPlace}
   */
  const leafletPlace = {
    ...transformResultToLeafletPlaces(searchRecord, 0, 0), // We don't need lng and lat params, so set to 0
    popupContent: <SearchResultPopup record={searchRecord} distance={distance} />,
  }

  const mapPlaces = [leafletPlace]
  return (
    <Box className={'place-map'}>
      <LeafletMap
        isLoading={false}
        places={mapPlaces}
        selectedPlaceId={searchRecord.id}
        center={[searchRecord.Latitude, searchRecord.Longitude]}
        zoomLevel={15}
      />
    </Box>
  )
}

export default PlaceMap
